import {Injectable} from '@angular/core';
import {BazzarvoiceManager} from 'src/app/data/manager/bazzarvoice/bazzarvoice.manager';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BazzarvoiceVm {
  constructor(private bzvManager: BazzarvoiceManager) { }

  getReviews(params?): Observable<any> {
    return this.bzvManager.reviews(params);
  }

  summary(params): Observable<any> {
    return this.bzvManager.summary(params);
  }

  setReview(data): Observable<any> {
    return this.bzvManager.setReviews(data);
  }
}
